// Reusable brand logo — Goddess Ambe Maa image inside a gold-framed medallion.
// Uses Wikimedia Commons Ambaji image (Special:FilePath returns the direct file).
export const AMBE_LOGO_URL =
  "https://commons.wikimedia.org/wiki/Special:FilePath/Aarasuri_Ambaji_Photo.jpg?width=240";

export default function BrandLogo({ size = 44, className = "" }) {
  return (
    <span
      className={`relative inline-grid place-items-center rounded-full overflow-hidden gold-border shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        boxShadow:
          "0 0 0 1px rgba(212,175,55,0.35), 0 6px 24px -8px rgba(212,175,55,0.4)",
        background:
          "radial-gradient(circle at 50% 30%, rgba(212,175,55,0.35), transparent 70%), #0A1428",
      }}
      aria-label="Jay Ambe Maa"
    >
      <img
        src={AMBE_LOGO_URL}
        alt="Goddess Ambe Maa"
        loading="eager"
        className="w-full h-full object-cover"
        style={{ filter: "saturate(1.05) contrast(1.05)" }}
      />
      {/* subtle gold rim ring */}
      <span
        aria-hidden
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{
          boxShadow: "inset 0 0 0 2px rgba(212,175,55,0.55)",
        }}
      />
    </span>
  );
}
